import { PerformanceModelsSearchResponse } from 'types/FindAHome/PerformanceModels';

export const crossMod: PerformanceModelsSearchResponse = {
  models: [
    {
      thumbnailImages: [
        {
          reference:
            'https://api.claytonhomes.com/images/MFG/INT/9da6219e-ad11-4cc9-90af-c026e5bdcc62.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/MFG/INT/f920044f-e4f5-4127-92e1-f4de694f37ea.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/MFG/INT/08008700-ede3-4550-b9e1-41d3c8aa3b84.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/MFG/EXT/aa180a4f-36e0-41ee-a2ca-5cdec1224082.jpg',
          imageType: 1,
          imageTypeAcronym: 'EXT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/MFG/EXT/5f5a2285-f14b-4244-afa0-c0f4564a1a6f.png',
          imageType: 1,
          imageTypeAcronym: 'EXT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/MFG/INT/b9e22b73-e633-4efd-b4a6-dae0d9ad0a85.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/MFG/INT/6d4efede-e8e8-4ba2-86dd-a0d7ad83f6a2.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/MFG/INT/f15dae02-14eb-4009-bd37-2d7edba2043c.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/MFG/INT/02941b5e-4fcc-4302-a4e6-99fecf45b2ee.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/MFG/INT/759397a6-3853-4752-94b5-115134fd507d.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/MFG/INT/bab6a845-7b3a-40ce-9cfd-6e124006e3da.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/MFG/INT/73ea32fb-3fe1-44b2-986a-4e19823b6296.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/MFG/FLP/2b3f81ab-2ee2-426a-b4ee-a3f64a5eb8a0.png',
          imageType: 4,
          imageTypeAcronym: 'FLP',
        },
      ],
      hasIfp: false,
      hasVirtualTour: false,
      isInStockInArea: true,
      startingInThePrice: null,
      tags: [
        'Kitchen Island',
        'Covered Porch',
        'Utility Room',
        'Open Floor Plan',
        'Double Sinks in Bath',
        'Garage',
        'Dining Room',
        'Drywall',
      ],
      isOnLand: false,
      isCrossMod: true,
      images: [],
      modelId: 18737,
      modelNumber: '25BLD32583AH',
      drawingId: 18247,
      floorPlanId: 0,
      name: 'KEENELAND',
      modelDescription: '',
      modelWidth: 32,
      modelLength: 58,
      minSquareFeet: 1767,
      maxSquareFeet: 1767,
      squareFeet: 1767,
      beds: 3,
      baths: 2,
      twoYearSalesCount: 6,
      isMultiSection: true,
      isModular: false,
      isBuildable: true,
      isWebEnabled: true,
      isDealerEntered: true,
      lineId: 2734,
      creationDate: '2019-11-29 03:00:31.9578973',
      lastModificationDate: '2022-08-31 05:00:29.1207498',
      hasQualityPhotos: true,
      hasVideo: false,
      hasPhotoRealRendering: true,
      hasIFP: false,
      hasMatterPort: false,
      hasDreamHomeDesign: false,
      thumbnailReference: null,
      has360VirtualTour: false,
      hasProperMediaForPublication: true,
      thumbnailImage: null,
      logoReference: null,
      startingInThePrices: null,
      isMhAdvantageHome: false,
      isPremierFinancingEligible: true,
    },
    {
      thumbnailImages: [
        {
          reference:
            'https://api.claytonhomes.com/images/mfg/int/e75d3222-8bab-4e35-83f6-93a6aa9d1a8d.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/mfg/ext/8ce198b2-8407-4c89-97f3-27296e7c5b2d.jpg',
          imageType: 1,
          imageTypeAcronym: 'EXT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/mfg/int/412004d9-105e-467b-bc61-428b2dd599fc.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/mfg/int/4c9be419-f347-46f6-aec0-d030ebe59149.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/mfg/int/84a5367f-5394-4b2c-92a3-10bdcf079917.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/MFG/FLP/cc204079-f568-42bf-aad7-43fbabec80b6.png',
          imageType: 4,
          imageTypeAcronym: 'FLP',
        },
      ],
      hasIfp: false,
      hasVirtualTour: false,
      isInStockInArea: true,
      startingInThePrice: null,
      tags: [],
      isOnLand: false,
      isCrossMod: true,
      images: [],
      modelId: 18777,
      modelNumber: '25BLD32603AH',
      drawingId: 18788,
      floorPlanId: 0,
      name: 'BELMONT',
      modelDescription: '',
      modelWidth: 32,
      modelLength: 60,
      minSquareFeet: 1767,
      maxSquareFeet: 1620,
      squareFeet: 1620,
      beds: 3,
      baths: 2,
      twoYearSalesCount: 1,
      isMultiSection: true,
      isModular: false,
      isBuildable: true,
      isWebEnabled: true,
      isDealerEntered: true,
      lineId: 2734,
      creationDate: '2020-01-08 03:00:29.4692715',
      lastModificationDate: '2022-08-31 05:00:29.1207498',
      hasQualityPhotos: true,
      hasVideo: false,
      hasPhotoRealRendering: true,
      hasIFP: false,
      hasMatterPort: false,
      hasDreamHomeDesign: false,
      thumbnailReference: null,
      has360VirtualTour: false,
      hasProperMediaForPublication: true,
      thumbnailImage: null,
      logoReference: null,
      startingInThePrices: null,
      isMhAdvantageHome: false,
      isPremierFinancingEligible: true,
    },
    {
      thumbnailImages: [
        {
          reference:
            'https://api.claytonhomes.com/images/mfg/int/98e12040-b77e-4e39-9fd7-5ffb7cb5d135.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/mfg/int/3a17fd52-235e-467e-94fa-432d7c9f98b4.jpg',
          imageType: 1,
          imageTypeAcronym: 'EXT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/mfg/int/d7083a73-0a11-4df3-8714-73e4d084d50a.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/mfg/ext/f7919c4e-9678-4882-ac0d-5821d505e012.jpg',
          imageType: 1,
          imageTypeAcronym: 'EXT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/mfg/ext/b0373975-dcae-4187-a99d-6281eb6bfabc.jpg',
          imageType: 1,
          imageTypeAcronym: 'EXT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/mfg/int/e09946fc-2142-4a59-8234-f7a0f41dcd44.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/mfg/int/3b09de4d-f2e4-4efd-ae56-f19f1ad34167.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/mfg/int/6691c45e-7083-4ae1-9a80-6a54186154b2.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/mfg/int/eaac3af0-fa1a-4ea5-b63d-7718f286827e.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/mfg/int/69db7041-aa36-41a5-9d05-93c826c89405.jpg',
          imageType: 2,
          imageTypeAcronym: 'INT',
        },
        {
          reference:
            'https://api.claytonhomes.com/images/MFG/FLP/c4c9245a-80c8-44a7-baad-13d3d27f38f6.png',
          imageType: 4,
          imageTypeAcronym: 'FLP',
        },
      ],
      hasIfp: false,
      hasVirtualTour: false,
      isInStockInArea: true,
      startingInThePrice: null,
      tags: [
        'Kitchen Island',
        'Covered Porch',
        'Utility Room',
        'Double Sinks in Bath',
        'Foyer',
        'Garage',
        'Dining Room',
        'Drywall',
      ],
      isOnLand: false,
      isCrossMod: true,
      images: [],
      modelId: 18735,
      modelNumber: '25BLD32643AH',
      drawingId: 18188,
      floorPlanId: 0,
      name: 'HAWTHORNE',
      modelDescription: '',
      modelWidth: 32,
      modelLength: 64,
      minSquareFeet: 1728,
      maxSquareFeet: 1728,
      squareFeet: 1728,
      beds: 3,
      baths: 2,
      twoYearSalesCount: 5,
      isMultiSection: true,
      isModular: false,
      isBuildable: true,
      isWebEnabled: true,
      isDealerEntered: true,
      lineId: 2734,
      creationDate: '2019-11-29 03:00:31.9578973',
      lastModificationDate: '2022-08-31 05:00:29.1207498',
      hasQualityPhotos: true,
      hasVideo: false,
      hasPhotoRealRendering: true,
      hasIFP: false,
      hasMatterPort: false,
      hasDreamHomeDesign: false,
      thumbnailReference: null,
      has360VirtualTour: false,
      hasProperMediaForPublication: true,
      thumbnailImage: null,
      logoReference: null,
      startingInThePrices: null,
      isMhAdvantageHome: false,
      isPremierFinancingEligible: true,
    },
  ],
  cityText: '',
  topSellingHomes: [
    {
      modelId: 1,
      modelNumber: '',
      modelDescription: '',
      thumbnailReference: 'https://api.claytonhomes.com/images/',
      startingInThePrice: 0,
      lowPrice: 0,
      highPrice: 0,
    },
  ],
  favoriteModels: [],
  paginationResults: {
    lastIndex: 0,
    totalResults: 3,
  },
  searchableTags: [
    {
      tagId: 119,
      description: 'Utility Room',
      isActive: true,
      parentTagId: 0,
      childTags: [],
      iconReference: null,
    },
    {
      tagId: 119,
      description: 'Utility Room',
      isActive: true,
      parentTagId: 0,
      childTags: [],
      iconReference: null,
    },
    {
      tagId: 130,
      description: 'Dining Room',
      isActive: true,
      parentTagId: 0,
      childTags: [],
      iconReference: null,
    },
    {
      tagId: 92,
      description: 'Kitchen Island',
      isActive: true,
      parentTagId: 0,
      childTags: [],
      iconReference: null,
    },
    {
      tagId: 124,
      description: 'Double Sinks in Bath',
      isActive: true,
      parentTagId: 0,
      childTags: [],
      iconReference: null,
    },
    {
      tagId: 128,
      description: 'Foyer',
      isActive: true,
      parentTagId: 0,
      childTags: [],
      iconReference: null,
    },
    {
      tagId: 131,
      description: 'Drywall',
      isActive: true,
      parentTagId: 0,
      childTags: [],
      iconReference: null,
    },
    {
      tagId: 107,
      description: 'Covered Porch',
      isActive: true,
      parentTagId: 0,
      childTags: [],
      iconReference: null,
    },
    {
      tagId: 129,
      description: 'Garage',
      isActive: true,
      parentTagId: 0,
      childTags: [],
      iconReference: null,
    },
  ],
};
